export enum AppointmentTimeFrameEnum {
    AllDescription = 'All',
    All = 0,
    Last7DaysDescription = 'Last 7 Days',
    Last7Days = 1,
    Last14DaysDescription = 'Last 14 Days',
    Last14Days = 2,
    CustomDescription = 'Custom',
    Custom = 3,
}
